export const ERROR_MESSAGE_LOGIN_FAILED = 'Login_failed'
export const ERROR_MESSAGE_INVALID_CREDENTIALS = 'InvalidCredentials'
export const ERROR_MESSAGE_NOT_AUTHORISED = 'Login_not_authorized'

export enum LoginModeEnum {
  initial,
  passwordPhase,
  newJoiner,
}
